import { render } from "./testPaper.vue?vue&type=template&id=175f3f31&scoped=true"
import script from "./testPaper.vue?vue&type=script&lang=js"
export * from "./testPaper.vue?vue&type=script&lang=js"

import "./testPaper.vue?vue&type=style&index=0&id=175f3f31&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175f3f31"]])

export default __exports__